import { ButtonProps } from '@chakra-ui/react';
import React, { FunctionComponent as FC, useState } from 'react';
import { MdCheckCircle, MdContentCopy } from 'react-icons/md';
import { useNavigatorPermission } from '../../hooks/useNavigatorPermission';
import { copyToClipboard } from '../../utils';
import MButton from './MButton';

export interface MCopyTextButtonProps extends ButtonProps {
  copyValue: string;
}

export const MCopyTextButton: FC<MCopyTextButtonProps> = React.forwardRef<
  any,
  MCopyTextButtonProps
>(({ copyValue, ...rest }: MCopyTextButtonProps, ref) => {
  const [isCopied, setIsCopied] = useState(false);
  const { canCopyClipboard } = useNavigatorPermission();

  const handleCopy = async () => {
    if (canCopyClipboard) {
      const didCopy = await copyToClipboard(copyValue);
      if (didCopy) {
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 3000);
      }
    }
  };

  return (
    <MButton
      ref={ref}
      onClick={handleCopy}
      variant="secondary"
      leftIcon={isCopied ? <MdCheckCircle /> : <MdContentCopy />}
      {...rest}
    >
      {isCopied ? 'Copied to Clipboard' : 'Copy to Clipboard'}
    </MButton>
  );
});
